import InSicht from 'insicht';

export default function (dom, opts) {
	let options = {

		singleNumberSel: '.figure',
		showSingleNumber: 'figure--show',
		reelSel: '.numbers-reel',
		hideReelCls: 'numbers-reel--hide',
		sectionSel: '.lead-section',
		runAnimationCls: 'numbers-reel--run',
		...opts
	};

	const allNumbers = Array.from(dom.querySelectorAll(options.singleNumberSel));
	const numberReel = Array.from(dom.querySelectorAll(options.reelSel));

	function init() {
		const stats = new InSicht({
			container: dom,
			selector: options.sectionSel,

			done: (counter) => {
				replaceNumber()
			}
		})
	}

	function replaceNumber() {
		numberReel.forEach(n => {
			n.classList.add(options.runAnimationCls);
		});

		setTimeout(() => {
			numberReel.forEach(number => {
				number.classList.add(options.hideReelCls);
			});
			allNumbers.forEach(all => {
				all.classList.add(options.showSingleNumber);
			})

		}, 1000);
	}

	init()

}
